import {useState, useEffect} from 'react';

const useScrollSpy = (contentText: string, wordPerMinute: number = 225) => {
    const [progress, setProgress] = useState(100);
    const [progressWidth, setProgressWidth] = useState(0);
    const [degree, setDegree] = useState(0);
    const [remainingTime, setRemainingTime] = useState<number | undefined>(undefined);

    const handleScroll = () => {
        const scrollDist = document.documentElement.scrollTop || document.body.scrollTop;
        setProgressWidth(
            (scrollDist / (document.body.scrollHeight - document.documentElement.clientHeight)) * 100,
        );
    };

    useEffect(() => {
        const words = contentText?.trim().split(/\s+/).length || 0;
        const totalReadingTime = Math.ceil(words / wordPerMinute);
        setRemainingTime(
            Math.floor((100 - progressWidth) * totalReadingTime / 100)
        );
        setProgress(
            100 - progressWidth
        );
        setDegree(
            360 * (100 - progressWidth) / 100
        );
    }, [progressWidth]);

    return {
        progress, 
        degree, 
        remainingTime, 
        progressWidth, 
        handleScroll
    };
}

export default useScrollSpy;